/**
 * Application Constants
 * Single source of truth for all hardcoded values across the application
 */

// ==================== IMAGE COMPRESSION ====================
/**
 * Default image compression settings
 * Used by imageCompression utility
 */
export const IMAGE_COMPRESSION = {
  MAX_WIDTH: 1600,
  MAX_HEIGHT: 1600,
  QUALITY: 0.7,
  MIME_TYPE: "image/jpeg",
};

// ==================== PAGINATION ====================
/**
 * Default pagination settings
 */
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [5, 10, 20, 50],
};

// ==================== JWT ====================
/**
 * JWT token settings
 */
export const JWT = {
  TOKEN_KEY: "token",
  PROJECT_ID_KEY: "project_id",
  PROJECT_NAME_KEY: "project_name",
  EMAIL_KEY: "email",
  NAMA_KEY: "nama",
  ROLE_KEY: "role", // NEW: Store user role
};

// ==================== USER ROLES ====================
/**
 * User role types for authorization
 */
export const ROLES = {
  SUPER_ADMIN: "super_admin",
  PROJECT_ADMIN: "project_admin",
  USER: "user",
};

// ==================== LESSON STATUS ====================
/**
 * Lesson approval status types
 */
export const LESSON_STATUS = {
  PENDING: "Pending",
  APPROVED: "Approved",
};

// ==================== ROUTES ====================
/**
 * Application routes
 */
export const ROUTES = {
  // Public
  LOGIN: "/login",
  PUBLIC_PORTAL: "/dashboard",
  LESSONS_DASHBOARD: "/dashboard/lessons",
  LESSONS_DASHBOARD_DETAIL: (id) => `/dashboard/lessons/${id}`,
  VAVE_DASHBOARD: "/dashboard/vave",

  // Protected - General
  HOME: "/portalknowledge",
  LOGO: "/logo",
  PORTAL: "/",

  // Protected - Lesson Management
  LESSONS: "/lessons",
  LESSONS_CREATE: "/lessons/create",
  LESSONS_PENDING: "/lessons/pending",
  LESSONS_DETAIL: (id) => `/lessons/${id}`,
  LESSONS_EDIT: (id) => `/lessons/${id}/edit`,

  // Protected - VA/VE Management
  VAVE: "/vave",
  VAVE_CREATE: "/vave/create",
  VAVE_EDIT: (id) => `/vave/${id}/edit`,

  // Admin Only
  USER_MANAGEMENT: "/user-management",
  CATEGORIES: "/categories",
  PROJECT: "/project",

  // Catch-all
  NOT_FOUND: "*",
};

// ==================== UI MESSAGES ====================
/**
 * Standard UI messages
 */
export const UI_MESSAGES = {
  EMPTY_DATA: "Data Tidak Ditemukan",
  LOADING: "Memuat data...",
  NO_RESULTS: "Tidak ada hasil yang ditemukan",
};

// ==================== PROGRESS ====================
/**
 * Progress-related constants
 */
export const PROGRESS = {
  STAGES: [0, 50, 100],
  MIN: 0,
  MAX: 100,
};

// ==================== ERROR MESSAGES ====================
/**
 * Standard error messages
 */
export const ERROR_MESSAGES = {
  NETWORK_ERROR: "Gagal terhubung ke server. Periksa koneksi internet Anda.",
  UNAUTHORIZED: "Sesi Anda telah berakhir. Silakan login kembali.",
  FORBIDDEN: "Anda tidak memiliki akses untuk melakukan aksi ini.",
  NOT_FOUND: "Data tidak ditemukan.",
  SERVER_ERROR: "Terjadi kesalahan pada server. Silakan coba lagi nanti.",
};

// ==================== SUCCESS MESSAGES ====================
/**
 * Standard success messages
 */
export const SUCCESS_MESSAGES = {
  CREATE: "Data berhasil ditambahkan.",
  UPDATE: "Data berhasil diperbarui.",
  DELETE: "Data berhasil dihapus.",
  UPLOAD: "File berhasil diupload.",
  DOWNLOAD: "Download berhasil.",
};
